export const styles = () => {
  return {
    indicatorContainer: {
      display: 'flex',
      justifyContent: 'center' as 'center',
      alignItems: 'center' as 'center',
      gap: 5,
      flexShrink: 0,
      boxSizing: 'border-box' as 'border-box',
    } as React.CSSProperties,
    indicatorText: {
      minWidth: '100%',
      textAlign: 'center' as 'center',
      alignSelf: 'center' as 'center',
    } as React.CSSProperties,
  };
};
